<template>
  <div>
    <h2 class="login__title">{{ $t(`${namespace}.title`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.text`) }}</p>

    <Button
      color="secondary"
      gradient
      block
      large
      @click="closeWindow"
    >
      {{ $t(`${namespace}.buttonLabel`) }}
    </Button>
  </div>
</template>

<script>
export default {
  name: 'Success',
  data () {
    return {
      namespace: 'Views.SAPConcurIntegrationPage'
    }
  },
  methods: {
    closeWindow () {
      window.close()
    }
  }
}
</script>
